import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";

const resource = "/webview";
export default {
  getLenderWebView(secretKey) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/data/${secretKey}`);
  },

  getSuccessUrl(secretKey) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/login/${secretKey}/success`);
  },

  resendOtp(secretKey) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(
      `${resource}/login/${secretKey}/otp/resend`
    );
  },

  verifyOtp(secretKey, otp) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(
      `${resource}/login/${secretKey}/otp/verify?otp=${otp}`
    );
  },

  getLenderOtpView(secretKey) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(
      `${resource}/data/${secretKey}/otp/send`
    );
  },


  verifyOtpAndGetResponse(secretKey, otp) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(
      `${resource}/${secretKey}/verifyOtp?otp=${otp}`
    );
  },
};
